import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { updateGreenHouseMaps } from 'app/state/green-house-map/green-house-map.actions';
import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { selectMasterData } from 'app/state/master-data/master-data.selectors';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class GreenHouseMapEffects {
    syncWithMasterDataStore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMasterDataStore),
            switchMap(() => this.store.select(selectMasterData)),
            map((masterData) => updateGreenHouseMaps({ greenHouseMapList: masterData?.maps ?? [] })),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
